module.exports = __webpack_public_path__ + "static/media/mev.aad9fac2.PNG";